/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ provider: NonNullable<unknown> }} Byoa_Get_KeyInputs */

const en_byoa_get_key = /** @type {(inputs: Byoa_Get_KeyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Open the ${i?.provider} keys page`)
};

const id_byoa_get_key = /** @type {(inputs: Byoa_Get_KeyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buka halaman kunci ${i?.provider}`)
};

/**
* | output |
* | --- |
* | "Open the {provider} keys page" |
*
* @param {Byoa_Get_KeyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const byoa_get_key = /** @type {((inputs: Byoa_Get_KeyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Byoa_Get_KeyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_byoa_get_key(inputs)
	return en_byoa_get_key(inputs)
});